import React from 'react';
import { ID, lAsync } from 'app/blocks/common/codes';
import showDialog from 'app/blocks/common/jsx/dialogModal';
import { confirm } from 'app/blocks/Modal/utils';
import OrcidDataModal from 'app/blocks/orcid/OrcidDataModal';
import AffiliationListFromOrcid from 'app/pages/profile/affiliation/jsx/affiliation-list-from-orcid';

async function confirmAffiliationImport(affiliations) {
    return confirm(<AffiliationListFromOrcid affiliations={affiliations} />, {
        confirmBtnLabel: await lAsync('PROFILE_ACCOUNT.uiLabelMessages.PROFILE_ACCNT_YES_BUTTON_LABEL'),
        cancelBtnLabel: await lAsync('PROFILE_ACCOUNT.uiLabelMessages.PROFILE_ACCNT_NO_BUTTON_LABEL'),
    });
}

async function confirmLogin(email) {
    const message = await lAsync(
        'PROFILE_ACCOUNT.confirmationMessages.PROFILE_ACCNT_ORCID_ALREADY_EXISTS_WINDOW_MESSAGE',
        { email_hint: `<b>${email}</b>` },
    );

    return confirm(message, {
        confirmBtnLabel: await lAsync(
            'PROFILE_ACCOUNT.confirmationMessages.PROFILE_ACCNT_ORCID_ALREADY_EXISTS_WINDOW_CONFIRM_LABEL',
        ),
        cancelBtnLabel: await lAsync(
            'PROFILE_ACCOUNT.confirmationMessages.PROFILE_ACCNT_ORCID_ALREADY_EXISTS_WINDOW_CANCEL_LABEL',
        ),
    });
}

async function confirmOrcidModifications(orcidData, errors) {
    return confirm(<OrcidDataModal errors={errors} orcidData={orcidData} />);
}

async function confirmOrcidRemoving() {
    return confirm(await lAsync('PROFILE_ACCOUNT.confirmationMessages.PROFILE_ACCNT_REMOVE_ORCID_PRE_CONF_TEXT'), {
        confirmBtnLabel: await lAsync('PROFILE_ACCOUNT.uiLabelMessages.PROFILE_ACCNT_YES_BUTTON_LABEL'),
        cancelBtnLabel: await lAsync('PROFILE_ACCOUNT.uiLabelMessages.PROFILE_ACCNT_NO_BUTTON_LABEL'),
    });
}

async function confirmRedirectToOrcid() {
    return confirm(await lAsync(`${ID.ORCID_POP_UP}.NOTIFICATION_TEXT`));
}

async function notifyUserThatThereAreNoOrcidAffiliations() {
    showDialog.info({
        message: await lAsync('PROFILE_ACCOUNT.confirmationMessages.PROFILE_ACCNT_EMPTY_ORCID_AFFILIATIONS_CONF_TEXT'),
    });
}

async function notifyUserThatOrcidImportingFailed(errors, onClose) {
    const message = errors.reduce(
        (text, error) => `${text}<p>${error}</p>`,
        `<p><strong>${await lAsync('ORCID_POP_UP.NOT_IMPORTED')}</strong></p>`,
    );

    showDialog.error({ message, onClose });
}

export {
    confirmAffiliationImport,
    confirmLogin,
    confirmOrcidModifications,
    confirmOrcidRemoving,
    confirmRedirectToOrcid,
    notifyUserThatOrcidImportingFailed,
    notifyUserThatThereAreNoOrcidAffiliations,
};
